import { useContext } from "react"
import { ensureArray } from "lib/ensure-array"
import { noop } from "lib/noop"
import { SwitchContext } from "lib/@components/switch"

export function Case({ when, then, children, execute = noop }) {
    const toCheck = ensureArray(when)
    const { value, cases } = useContext(SwitchContext)
    const condition = toCheck.some((whenCondition) => {
        if (typeof whenCondition === "function") {
            return whenCondition(value)
        }
        return whenCondition === value
    })

    cases[`${when}`] = condition
    if (condition) {
        execute()
        return <>{then || children}</>
    }
    return null
}

// Backward-compatible re-export
export { CaseElse } from "lib/@components/case-else"
